/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MonitEntityMappingResult } from './MonitEntityMappingResult';
import {
    MonitEntityMappingResultFromJSON,
    MonitEntityMappingResultFromJSONTyped,
    MonitEntityMappingResultToJSON,
} from './MonitEntityMappingResult';

/**
 * 
 * @export
 * @interface MonitEntityMappingResponse
 */
export interface MonitEntityMappingResponse {
    /**
     * 
     * @type {number}
     * @memberof MonitEntityMappingResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof MonitEntityMappingResponse
     */
    page_size?: number;
    /**
     * 
     * @type {number}
     * @memberof MonitEntityMappingResponse
     */
    count?: number;
    /**
     * 
     * @type {Array<MonitEntityMappingResult>}
     * @memberof MonitEntityMappingResponse
     */
    results?: Array<MonitEntityMappingResult>;
}

/**
 * Check if a given object implements the MonitEntityMappingResponse interface.
 */
export function instanceOfMonitEntityMappingResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitEntityMappingResponseFromJSON(json: any): MonitEntityMappingResponse {
    return MonitEntityMappingResponseFromJSONTyped(json, false);
}

export function MonitEntityMappingResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitEntityMappingResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
        'count': !exists(json, 'count') ? undefined : json['count'],
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(MonitEntityMappingResultFromJSON)),
    };
}

export function MonitEntityMappingResponseToJSON(value?: MonitEntityMappingResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'count': value.count,
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(MonitEntityMappingResultToJSON)),
    };
}

